import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import RadioButtonOption from 'login/components/Inputs/RadioButton/RadioButtonOption.jsx';

import 'login/components/Inputs/RadioButton/RadioButtonContainer.scss';

class RadioButtonContainer extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(event) {
        const value = event.target.value;
        this.props.valueChangeCallback(value);
    }

    render() {
        return (
            <div className="radio-button-container" onChange={this.handleChange}>
                {this.props.options.map((option) => (
                    <RadioButtonOption
                        name={this.props.name}
                        value={option.value}
                        label={LocaleService.t(option.label)}
                        selected={this.props.selected === option.value}
                    />
                ))}
            </div>
        );
    }
}

RadioButtonContainer.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    valueChangeCallback: PropTypes.func.isRequired,
    name: PropTypes.string.isRequired,
    selected: PropTypes.number,
};

RadioButtonContainer.defaultProps = {
    selected: 0,
};

RadioButtonContainer.displayName = 'RadioButtonContainer';

export default RadioButtonContainer;
